"use client";

const BRAND = {
  primary: "#3B82F6",
  primarySoft: "rgba(59, 130, 246, 0.08)",
  danger: "#EF4444",
  muted: "#6B7280",
  border: "#E5E7EB",
};

export default function TrafficLimitReachedPage() {
  return (
    <>

      <div className="bg-white">
        {/* ================= HERO ================= */}
        <section
          className="text-white"
          style={{
            background: "linear-gradient(135deg, #0f172a, #1e3a8a)",
          }}
        >
          <div className="container py-4 text-center">
            <span className="badge bg-warning text-dark mb-3 px-3 py-2">
              Link Temporarily Paused
            </span>
            <h1 className="fw-bold mt-3 mb-2">
              Traffic Limit Reached
            </h1>
            <p className="opacity-75 mb-0">
              This link has exceeded its allowed monthly traffic.
            </p>
          </div>
        </section>

        {/* ================= CONTENT ================= */}
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">

                {/* Status Card */}
                <div
                  className="rounded-4 p-4 p-md-5 mb-4"
                  style={{
                    backgroundColor: "#fff",
                    border: `1px solid ${BRAND.border}`,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                  }}
                >
                  <div className="text-center mb-4">
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: 56,
                        height: 56,
                        backgroundColor: BRAND.primarySoft,
                        color: BRAND.primary,
                        fontSize: 24,
                        fontWeight: 700,
                      }}
                    >
                      !
                    </div>

                    <h4 className="fw-semibold mb-2">
                      Monthly Traffic Limit Exceeded
                    </h4>

                    <p className="text-muted mb-0">
                      The owner of this short link has reached the maximum number
                      of clicks allowed under their current subscription plan.
                    </p>
                  </div>

                  <hr className="my-4" />

                  <div className="text-muted fs-6">
                    <p className="mb-2">
                      • Redirection is automatically paused to prevent
                      over-usage.
                    </p>
                    <p className="mb-2">
                      • Access will resume when the monthly limit resets or the
                      plan is upgraded.
                    </p>
                    <p className="mb-0">
                      • No data or analytics have been lost.
                    </p>
                  </div>
                </div>

                {/* CTA Section */}
                <div className="text-center">
                  <p className="text-muted mb-4">
                    If you manage this link, you can restore access instantly.
                  </p>

                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <a
                      href="/account/upgrade"
                      className="btn btn-primary px-4 py-2"
                    >
                      Upgrade Plan
                    </a>

                    <a
                      href="/user-dashboard"
                      className="btn btn-outline-secondary px-4 py-2"
                    >
                      Open Dashboard
                    </a>
                  </div>

                  <p className="mt-4 small text-muted">
                    Powered by u2lr · Smart link management & analytics
                  </p>
                </div>

              </div>
            </div>
          </div>
        </section>

        {/* ================= FOOT NOTE ================= */}
        <section
          className="text-center py-4"
          style={{ backgroundColor: BRAND.primarySoft }}
        >
          <p className="mb-0 text-muted">
            u2lr helps teams manage traffic, performance, and growth responsibly.
          </p>
        </section>
      </div>
    </>
  );
}